// extracted by mini-css-extract-plugin
export default {"shadowed":"About_shadowed__--OxJ","pink":"About_pink__SHJhp","green":"About_green__L4X3U","skills":"About_skills__-8-69"};